import { gql } from 'urql';

const TabaPayCardDetails = gql`
  query TabaPayCardDetails {
    tabaPayCardDetails {
      __typename
      ... on TabaPayCardDetailsSuccess {
        id
        title
        description
        __typename
        cardHolderName {
          first
          last
          full
          initials
        }
        associatedExternalCardAddresses {
          address {
            addressLine1
            addressLine2
            city
            state
            zip
            country
            externalId
          }
          isProfileAddress
        }
        disclaimer
      }
      ... on TabaPayCardDetailsError {
        __typename
        message
        code
      }
    }
  }
`;

export default TabaPayCardDetails;
